<template>
  <main class="activate-page">
    <div class="activate-card">
      <div class="activate-brand">
        <div class="activate-brand-mark"></div>
        <div class="activate-brand-name">激活个人账号</div>
      </div>

      <el-form ref="form" :model="form" :rules="rules" class="activate-form" label-position="top">
        <el-form-item label="邮箱地址" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱地址" size="large" />
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input v-model="form.code" placeholder="6 位验证码" size="large" maxlength="6" />
        </el-form-item>
        <el-form-item label="设置密码" prop="password">
          <el-input v-model="form.password" type="password" placeholder="至少 6 位密码" size="large" show-password />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="form.confirmPassword" type="password" placeholder="再次输入密码" size="large" show-password />
        </el-form-item>
        <el-button type="primary" size="large" class="activate-btn" :loading="submitting" @click="submitActivate">
          激活
        </el-button>
      </el-form>

      <div class="activate-footer">
        <span>已有账号？<a href="#/login">直接登录</a></span>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'ActivatePersonalPage',
  data() {
    return {
      submitting: false,
      form: {
        email: '',
        code: '',
        password: '',
        confirmPassword: ''
      },
      rules: {
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 6, message: '验证码为 6 位数字', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请设置密码', trigger: 'blur' },
          { min: 6, message: '密码至少 6 位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (value !== this.form.password) {
              callback(new Error('两次密码输入不一致'))
            } else {
              callback()
            }
          }, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async submitActivate() {
      const valid = await this.$refs.form.validate().catch(() => false)
      if (!valid) return
      this.submitting = true
      try {
        await this.$http.post('/admin/personal-accounts/activate', {
          email: this.form.email,
          code: this.form.code,
          password: this.form.password
        })
        this.$message.success('激活成功')
        this.$router.push('/login')
      } catch (e) {
        this.$message.error(e.response?.data?.error || '激活失败')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.activate-page {
  width: 100vw;
  min-height: 100vh;
  display: grid;
  place-items: center;
  position: relative;
  overflow: hidden;
  padding: 28px;
  background:
    radial-gradient(circle at 16% 84%, rgba(50, 200, 245, 0.12), transparent 32%),
    radial-gradient(circle at 84% 14%, rgba(139, 120, 255, 0.14), transparent 30%),
    linear-gradient(135deg, #101927 0%, #121f31 48%, #0f1724 100%);
}

.activate-page::before {
  content: "";
  position: absolute;
  inset: 7%;
  border: 1px solid rgba(50, 200, 245, 0.08);
  border-radius: 8px;
  background:
    linear-gradient(rgba(50, 200, 245, 0.025) 1px, transparent 1px),
    linear-gradient(90deg, rgba(79, 134, 255, 0.026) 1px, transparent 1px);
  background-size: 34px 34px;
  -webkit-mask-image: radial-gradient(circle at center, black, transparent 78%);
  mask-image: radial-gradient(circle at center, black, transparent 78%);
  pointer-events: none;
}

.activate-page::after {
  content: "AI ROUTER  /  SECURE ACCESS  /  TOKEN LEDGER";
  position: absolute;
  left: 50%;
  bottom: 34px;
  transform: translateX(-50%);
  color: rgba(154, 170, 193, 0.28);
  font-size: 11px;
  font-weight: 900;
  white-space: nowrap;
  letter-spacing: 0;
}

.activate-card {
  width: min(500px, calc(100vw - 44px));
  padding: 50px 48px 42px;
  text-align: center;
  position: relative;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(27, 39, 58, 0.94), rgba(19, 29, 45, 0.92));
  border: 1px solid rgba(151, 171, 207, 0.22);
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.28);
  backdrop-filter: blur(18px);
  border-radius: 8px;
  z-index: 1;
}

.activate-card::before {
  content: "";
  position: absolute;
  inset: 0 0 auto 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(50, 200, 245, 0.8), rgba(79, 134, 255, 0.82), transparent);
}

.activate-brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  margin-bottom: 30px;
}

.activate-brand-mark {
  width: 72px;
  height: 72px;
  border-radius: 22px;
  display: grid;
  place-items: center;
  background:
    radial-gradient(circle at 28% 18%, rgba(255,255,255,.94) 0 3%, transparent 4%),
    radial-gradient(circle at 76% 74%, rgba(37,240,255,.42), transparent 42%),
    radial-gradient(circle at 18% 78%, rgba(118,126,255,.28), transparent 36%),
    linear-gradient(150deg, rgba(255,255,255,.18), transparent 34%),
    linear-gradient(145deg, #10203a 0%, #12678b 48%, #20d6f4 100%);
  border: 1px solid rgba(183, 239, 255, .46);
  box-shadow: 0 26px 52px rgba(35,215,255,.3), 0 0 38px rgba(126,236,255,.18), inset -14px -16px 22px rgba(3,8,18,.52), inset 10px 10px 18px rgba(255,255,255,.16);
  flex: none;
  position: relative;
  overflow: hidden;
}

.activate-brand-mark::before {
  content: "";
  position: absolute;
  width: 32px;
  height: 32px;
  clip-path: polygon(50% 0%, 88% 22%, 88% 78%, 50% 100%, 12% 78%, 12% 22%);
  background:
    linear-gradient(135deg, rgba(255,255,255,.98), rgba(205,252,255,.8) 30%, rgba(35,215,255,.35) 31%, rgba(94,118,255,.58) 100%);
  box-shadow: 0 10px 22px rgba(0,0,0,.38), 0 0 22px rgba(66,236,255,.58), inset 0 0 0 1px rgba(255,255,255,.76), inset -5px -6px 10px rgba(5,12,25,.28);
  z-index: 2;
}

.activate-brand-mark::after {
  content: "";
  position: absolute;
  inset: 8px;
  background: no-repeat center/100% 100% url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 72 72' fill='none'%3E%3Cpath d='M5 43C18 26 54 23 67 11' stroke='%23ffe7a6' stroke-width='3.2' stroke-linecap='round' opacity='.98'/%3E%3Cpath d='M5 44C18 60 53 56 67 38' stroke='%2325f0ff' stroke-width='3.6' stroke-linecap='round' opacity='1'/%3E%3Cpath d='M18 18C31 8 50 12 58 27C47 22 29 23 18 35' stroke='%2398f7ff' stroke-width='2.2' stroke-linecap='round' opacity='.72'/%3E%3Ccircle cx='7' cy='43' r='4.1' fill='%23ffffff'/%3E%3Ccircle cx='67' cy='11' r='3.7' fill='%23ffe7a6'/%3E%3Ccircle cx='67' cy='38' r='4.1' fill='%2325f0ff'/%3E%3Ccircle cx='36' cy='36' r='12' stroke='%23ffffff' stroke-width='2.4' opacity='.82'/%3E%3C/svg%3E");
  filter: drop-shadow(0 0 11px rgba(37,240,255,.56));
  opacity: .98;
  z-index: 1;
}

.activate-brand-name {
  font-size: 28px;
  font-weight: 900;
  color: var(--text);
  line-height: 1.15;
  letter-spacing: 0.02em;
}

.activate-form {
  margin-bottom: 8px;
  text-align: left;
}

.activate-form ::v-deep .el-form-item {
  margin-bottom: 18px;
}

.activate-form ::v-deep .el-form-item__label {
  color: var(--muted);
  font-size: 13px;
  padding-bottom: 6px;
  line-height: 1.4;
}

.activate-form ::v-deep .el-input__inner {
  height: 56px;
  border-radius: 8px;
  border: 1px solid rgba(151, 171, 207, 0.24);
  background: rgba(255, 255, 255, 0.055);
  color: var(--text);
  font-size: 16px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035);
}

.activate-form ::v-deep .el-input__inner::placeholder {
  color: #71839b;
}

.activate-form ::v-deep .el-input__inner:focus {
  border-color: rgba(50, 200, 245, 0.46);
  box-shadow: 0 0 0 3px rgba(50, 200, 245, 0.07);
}

.activate-form ::v-deep .el-input__suffix,
.activate-form ::v-deep .el-input__icon {
  color: #8fa3bd;
}

.activate-form ::v-deep .el-input.is-active .el-input__inner,
.activate-form ::v-deep .el-input__inner:focus {
  border-color: rgba(50, 200, 245, 0.46);
}

.activate-btn {
  width: 100%;
  height: 58px;
  margin-top: 4px;
  font-size: 18px;
  font-weight: 850;
  border: 0;
  border-radius: 8px;
  background: linear-gradient(135deg, #4f86ff, #32bde8);
  color: #fff;
  box-shadow: 0 10px 28px rgba(50, 150, 245, 0.18);
  transition: box-shadow 0.25s, transform 0.2s;
}

.activate-btn:hover {
  box-shadow: 0 14px 36px rgba(50, 150, 245, 0.32);
  transform: translateY(-1px);
}

.activate-footer {
  text-align: center;
  font-size: 14px;
  color: var(--muted);
  margin-top: 22px;
}

.activate-footer a {
  color: #8eddf8;
  text-decoration: none;
  font-weight: 900;
}

.activate-footer a:hover {
  text-decoration: underline;
}

@media (max-width: 760px) {
  .activate-card {
    padding: 42px 26px 34px;
  }
  .activate-brand-name {
    font-size: 24px;
  }
}
</style>